//COMMON
import 'intersection-observer';
import './common';

//VUE CONFIG
// import './vueConfig';

//SASS - COMMON
import '../sass/main.scss';

import {
    scrollToY
} from './helpers/helpers'

import './sections/section-search-hint';

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

const homePage = document.querySelector('.home-page');
const html = document.querySelector('html');

window.onscroll = function () {
    myFunction()
};

var headerHolder = document.getElementById("headerHolder");

function myFunction() {
    if (window.pageYOffset > 86) {
        headerHolder.classList.add("sticky")
        if (homePage) {
            productMenu();
        }
    } else {
        headerHolder.classList.remove("sticky");
        if (homePage) {
            document.querySelector('[data-product-menu]').classList.remove('active');
        }
    }
}


if (!homePage) {
    productMenu();
}

function productMenu() {
    const productMenu = document.querySelector('[data-product-menu]');;
    if (productMenu) {
        productMenu.addEventListener('mouseover', function () {
            if (homePage && window.pageYOffset > 0) {
                productMenu.classList.add('active');
            }
            if (!homePage) {
                productMenu.classList.add('active');
            }
        })
        productMenu.addEventListener('mouseleave', function () {
            productMenu.classList.remove('active');
        })
    }
}


const productsNav = document.getElementById('products-nav');

if (productsNav) {
    const links = productsNav.querySelectorAll('.products-nav__link');

    links.forEach(link => {
        const number = link.dataset.linkProduct;
        link.addEventListener('mouseover', function () {
            const contentItem = productsNav.querySelector("[data-content-product='" + number + "']")

            if (contentItem) {
                removeActive();
                contentItem.classList.add('active');
                link.classList.add('active');
            } else {
                removeActive();
            }
        })
    })

    function removeActive() {
        const contentsItem = productsNav.querySelectorAll('.products-nav__content-item');
        const links = productsNav.querySelectorAll('.products-nav__link');
        contentsItem.forEach(el => {
            el.classList.remove('active');
        })
        links.forEach(el => {
            el.classList.remove('active');
        })
    }
}

const footerCol = document.querySelectorAll('[data-footerCol]');

if (footerCol) {
    footerCol.forEach(el => {
        const button = el.querySelector('.toggle-button-nav');

        button.addEventListener('click', function (e) {
            e.preventDefault();
            el.classList.toggle('active');
        })
    })
}

window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function (callback) {
            window.setTimeout(callback, 1000 / 60);
        };
})();


// scrollowanie do góry

var scrollme = document.querySelector("#scrollUp");
scrollme.addEventListener("click", function (e) {
    e.preventDefault();
    scrollToY(0, 1500, 'easeInOutQuint');
}, false)

const productAddedPopup = document.querySelector('#productAddedPopup');
if (productAddedPopup) {
    productAddedPopup.addEventListener('click', e => {
        e.preventDefault();
        if (e.target.classList.contains('close-modal-basket')) {
            const modalAddBasket = document.getElementById('modalAddBasket');
            modalAddBasket.classList.add('remove');
            setTimeout(function () {
                modalAddBasket.remove();
            }, 10);
        } else {
            if (e.target.nodeName == 'A') {
                location.href = e.target.href;
            }
        }
    });
}

const closeMessageProduct = document.querySelectorAll('.close-message-product');
const modalMessageProduct = document.getElementById('modalMessageProduct');

if (closeMessageProduct) {
    closeMessageProduct.forEach(el => {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            modalMessageProduct.style.display='none';
//            modalMessageProduct.classList.add('remove');
//            setTimeout(function () {
//                modalMessageProduct.remove();
//            }, 10)
        });
    });
}


const headerBasket = document.getElementById('headerBasket');

if (headerBasket && window.innerWidth > 1024) {
    headerBasket.addEventListener('mouseover', function () {
        headerBasket.classList.add('active');
    })
    headerBasket.addEventListener('mouseleave', function () {
        headerBasket.classList.remove('active');
    })
}

/*
const headerSearch = document.getElementById('headerSearch');

if (headerSearch && window.innerWidth > 1024) {
    const input = headerSearch.querySelector('input');
    const searchHints = headerSearch.querySelector('#searchHints');

    input.addEventListener('input', function (e) {
        console.log(e.target.value)

        if (e.target.value == '') {
            headerSearch.classList.remove('active')
        } else {

            const text = `<div class="header-serach__hints-left">
        <div class="header-serach__hints-category">
            <span class="header-serach__hints-heading">Kategorie</span>
            <ul>
                <li class="search-category"><a href="">Kotły i piece</a></li>
                <li class="search-category"><a href="">Pompy ciepła</a></li>
                <li class="search-category"><a href="">Rekuperacja</a></li>
                <li class="search-category"><a href="">Ogrzewanie</a></li>
            </ul>
        </div>
        <div class="header-serach__hints-brand">
            <span class="header-serach__hints-heading">Marki</span>
            <ul>
                <li class="search-brand"><a href="">Atlantic</a></li>
                <li class="search-brand"><a href="">Galmet</a></li>
                <li class="search-brand"><a href="">Immergas</a></li>
                <li class="search-brand"><a href="">Lg</a></li>
            </ul>
        </div>
    </div>
    <div class="header-serach__hints-right">
        <span class="header-serach__hints-heading">Produkty</span>
        <div class="">
            <a href="" class="search-product">
                <div class="search-product__img">
                    <img src="{$templates_dir}img/category/kotly_i_piece.jpg" alt="">
                </div>
                <div class="search-product__text">
                    <span class="name">Rekuperator Viteco R200 z wymiennikiem
                        przeciwprądowym</span>
                    <span class="seria">F0001037</span>
                </div>
            </a>
            <a href="" class="search-product">
                <div class="search-product__img">
                    <img src="{$templates_dir}img/category/kotly_i_piece.jpg" alt="">
                </div>
                <div class="search-product__text">
                    <span class="name">Rekuperator Viteco R200 z wymiennikiem
                        przeciwprądowym</span>
                    <span class="seria">F0001037</span>
                </div>
            </a>
            <a href="" class="search-product">
                <div class="search-product__img">
                    <img src="{$templates_dir}img/category/kotly_i_piece.jpg" alt="">
                </div>
                <div class="search-product__text">
                    <span class="name">Rekuperator Viteco R200 z wymiennikiem
                        przeciwprądowym</span>
                    <span class="seria">F0001037</span>
                </div>
            </a>
            <a href="" class="search-product">
                <div class="search-product__img">
                    <img src="{$templates_dir}img/category/kotly_i_piece.jpg" alt="">
                </div>
                <div class="search-product__text">
                    <span class="name">Rekuperator Viteco R200 z wymiennikiem
                        przeciwprądowym</span>
                    <span class="seria">F0001037</span>
                </div>
            </a>
        </div>
    </div>
    <a href="" class="header-serach__link">Wyświetl wszystkie wyniki</a>`

            searchHints.innerHTML = text;
            headerSearch.classList.add('active')


        }

    })
}
*/
document.addEventListener("click", (evt) => {
    let targetElement = evt.target;

    if (headerSearch.classList.contains('active')) {
        do {
            if (targetElement.id == 'searchHints' || targetElement.id == 'searchWord') {
                return;
            } else
                targetElement = targetElement.parentNode;

        } while (targetElement);

        headerSearch.classList.remove('active')
    }

});


docReady(function () {
    const controlInput = document.querySelectorAll('.control-input');

    if (controlInput) {
        controlInput.forEach(el => {
            const input = el.querySelector('input:not([disabled])');

            if (input) {
                if (input.value !== '') {
                    el.classList.add('focus-control');
                } else {
                    el.classList.remove('focus-control');
                }
                input.addEventListener('input', function (e) {
                    if (this.value !== '') {
                        el.classList.add('focus-control');
                    } else {
                        el.classList.remove('focus-control');
                    }
                })
            }
        })
    }

    const controlTextarea = document.querySelectorAll('.control-textarea');

    if (controlTextarea) {
        controlTextarea.forEach(el => {
            const input = el.querySelector('textarea');

            input.addEventListener('input', function (e) {
                if (this.value !== '') {
                    el.classList.add('focus-control');
                } else {
                    el.classList.remove('focus-control');
                }
            })
        })
    }

    const selectBox = document.querySelectorAll('.select-box');

    if (selectBox) {
        selectBox.forEach(select => {
            const selected = select.querySelector(".selected");
            const optionsContainer = select.querySelector(".options-container");

            const optionsList = select.querySelectorAll(".option");

            selected.addEventListener("click", () => {
                optionsContainer.classList.toggle("active");
            });

            optionsList.forEach(o => {
                o.addEventListener("click", (e) => {
                    selected.innerHTML = o.querySelector("label").innerHTML;
                    optionsContainer.classList.remove("active");
                    if(e.target.tagName!='INPUT')
                        o.querySelector('input').click();
                });
            });
        })
    }
});

const setBasketSummaryEvents = (target) => {
    const item = target.parentNode;
    const minusBtn = item.querySelector('.product-count__minus');
    const plusBtn = item.querySelector('.product-count__plus');
    const input = item.querySelector('.product-count__input');
    if (!input) return;
    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || 99;
    const step = parseInt(input.step) || 1;

    if (target === minusBtn) {
        if (input.value > min) {
            input.value = parseInt(input.value) - step;
            inputUpdate(input);
        }
    } else if (target === plusBtn) {
        if (input.value < max) {
            input.value = parseInt(input.value) + step;
            inputUpdate(input);
        }
    } else if (target === input) {
        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(function () {
            inputUpdate(target);
        }, 600);
    }

    function inputUpdate(input) {
        var value = parseInt(input.value);

        if (value < min) {
            input.value = min;
        } else if (value > max) {
            input.value = max;
        } else if (input.value % step) {
            input.value = Math.floor(input.value / step) * step;
        } else {
            input.value = value;
        }
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            xajax_exe('BasketModule-xajaxBasketChange', xajax.getFormValues('basketShortForm'));
        }, 1000);
    }
};
const basketSummary = document.querySelector('#headerBasket');
if (basketSummary) {
    var timer;
    basketSummary.addEventListener('click', (e) => {
        if (e.target.classList.contains('product-count__minus') || e.target.classList.contains('product-count__plus')) {
            setBasketSummaryEvents(e.target);
        } else if (e.target.classList.contains('basket-remove')) {
            if (e.target.dataset.key) {
                e.preventDefault();
                xajax_exe('BasketModule-xajaxBasketDelete', e.target.dataset.key);
                // element.closest('.basket-list__item').remove();
            }
        } else if (e.target.parentNode.classList.contains('basket-remove')) {
            if (e.target.parentNode.dataset.key) {
                e.preventDefault();
                xajax_exe('BasketModule-xajaxBasketDelete', e.target.parentNode.dataset.key);
                // element.closest('.basket-list__item').remove();
            }
        }
    });
    basketSummary.addEventListener('input', (e) => {
        if (e.target.classList.contains('product-count__input')) {
            setBasketSummaryEvents(e.target);
        }
    });
    basketSummary.addEventListener('keypress', function (e) {
        if (e.keyCode === 45 || e.target.value.toString().length === 3) {
            e.preventDefault();
        }
    })
}

window.basketSummarys = () => {
    // zmiana sztuk danej pozycji

    const itemProductAction = document.querySelectorAll('[data-product-count]');

    if (itemProductAction) {
        var timer;
        itemProductAction.forEach(item => {
            const minusBtn = item.querySelector('.product-count__minus');
            const plusBtn = item.querySelector('.product-count__plus');
            const input = item.querySelector('.product-count__input');
            if (!input) return;
            const min = parseInt(input.min) || 1;
            const max = parseInt(input.max) || 99;
            const step = parseInt(input.step) || 1;

            minusBtn.addEventListener('click', function () {
                if (input.value > min) {
                    input.value = parseInt(input.value) - step;
                    inputUpdate(input);
                }
            })

            plusBtn.addEventListener('click', function () {
                if (input.value < max) {
                    input.value = parseInt(input.value) + step;
                    inputUpdate(input);
                }
            })

            input.addEventListener('keypress', function (e) {
                if (e.keyCode === 45 || this.value.toString().length === 3) {
                    e.preventDefault();
                }
            })

            function inputUpdate(input) {
                var value = parseInt(input.value);

                if (value < min) {
                    input.value = min;
                } else if (value > max) {
                    input.value = max;
                } else if (input.value % step) {
                    input.value = Math.floor(input.value / step) * step;
                } else {
                    input.value = value;
                }
                if (timer) {
                    clearTimeout(timer);
                }
                timer = setTimeout(function () {
                    xajax_exe('BasketModule-xajaxBasketChange', xajax.getFormValues('basketShortForm'));
                }, 1000);
            }

            input.addEventListener('input', function (e) {
                if (timer) {
                    clearTimeout(timer);
                }

                timer = setTimeout(function () {
                    inputUpdate(e.target);
                }, 600);
            })
        })
    }


    // usunięcie z koszyka danej pozycji

    const deletedElement = document.querySelectorAll('[data-product-remove]');

    if (deletedElement) {
        deletedElement.forEach(element => {
            element.addEventListener('click', function (e) {
                if (element.dataset.key) {
                    e.preventDefault();
                    xajax_exe('BasketModule-xajaxBasketDelete', element.dataset.key);
                    // element.closest('.basket-list__item').remove();
                }
            })
        })
    }
}

//basketSummary();

const dataNavToggle = document.querySelectorAll('[data-nav-toggle]');

if (dataNavToggle) {
    dataNavToggle.forEach(linkMain => {
        const link = linkMain.querySelector('.navbar-mobile__link');
        const dataNavSubtoggle = linkMain.querySelectorAll('[data-nav-subtoggle]');
        link.addEventListener('click', function (e) {
            e.preventDefault();
            if (linkMain.classList.contains('active')) {
                linkMain.classList.remove('active');
            } else {
                linkMain.classList.add('active');
            }
        })
        dataNavSubtoggle.forEach(subLink => {
            const link = subLink.querySelector('.navbar-mobile-submenu__link');
            link.addEventListener('click', function (e) {
                e.preventDefault();
                if (subLink.classList.contains('active')) {
                    subLink.classList.remove('active');
                } else {
                    subLink.classList.add('active');
                }
            })
        })
    })
}


const mobileMenuButtonOpen = document.getElementById('mobileMenuButtonOpen');
const mobileMenuButtonClose = document.getElementById('mobileMenuButtonClose');
const mobileMenu = document.getElementById('mobileMenu');

if (mobileMenuButtonOpen) {
    mobileMenuButtonOpen.addEventListener('click', function (e) {
        e.preventDefault();
        if (mobileMenu) {
            mobileMenu.classList.add('active');
            html.classList.add('overscroll-hidden');
        }
    })
}

if (mobileMenuButtonClose) {
    mobileMenuButtonClose.addEventListener('click', function (e) {
        e.preventDefault();
        if (mobileMenu) {
            mobileMenu.classList.remove('active');
            mobileMenu.querySelectorAll('.active').forEach(el => {
                el.classList.remove('active');
            })
            html.classList.remove('overscroll-hidden');
        }
    })
}

const switchPrice = document.querySelectorAll(".price-type-toggle a");
if (switchPrice) {
    switchPrice.forEach(el => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const type = e.target.dataset.type;
            switchPrice.forEach(el => {
                el.classList.toggle('active');
            });
            const date = new Date();
            date.setDate(date.getDate() + 365);
            document.cookie = 'price-type=' + type + '; expires=' + date.toUTCString() + '; path=/';

            const prices = document.querySelectorAll('.price-tag');
            if (prices) {
                prices.forEach(el => {
                    el.innerHTML = (type == 1 ? el.dataset.priceNet : el.dataset.priceGross);
                });
            }
        });
    });
}

const favourites = document.querySelectorAll("a.favorite");
if (favourites) {
    favourites.forEach(f => {
        f.addEventListener('click', (e) => {
            e.preventDefault();
            const a = e.target.parentElement.closest('a');
            a.classList.toggle('active');
            xajax_exe('WishlistModule-xajaxUpdate', [a.dataset.product]);
        });
    });
}

const basketAddButton = document.querySelectorAll('a.icon-basket-add'); //console.log(basketAddButton);
if (basketAddButton) {
    basketAddButton.forEach(b => {
        b.addEventListener('click', (e) => {
            xajax_exe('BasketModule-xajaxBasketAdd', form2object(e.target.parentElement.closest('form')));
            e.preventDefault();
        });
    });
}

const form2object = (form) => {
    const obj = {};
    form.elements.forEach(e => {
        obj[e.name] = e.value;
    });
    return obj;
}

function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}



const modalComplaintClose = document.getElementById('modalComplaintClose');
const modalComplaint = document.getElementById('modalComplaint');

console.log(modalComplaintClose)

if (modalComplaintClose) {
    modalComplaintClose.addEventListener('click', function (e) {
        e.preventDefault();
        modalComplaint.classList.add('remove');
        setTimeout(function () {
            modalComplaint.remove();
        }, 10)
    })
}